import styled from "styled-components";

export const ContentHeaderBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray400};
  margin-bottom: 1.25rem;
  align-items: center;

  @media print {
    display: none;
  }
`;
